import Select from "Select";
import {Field} from "redux-form";
import React, {useEffect} from "react";
import {useDispatch, useSelector} from "react-redux";
import Styles from "../../styles.scss";
import {adaptInputValues} from "../../utils";
import {advancedFilterActions} from "../../../../actions/filters";
import {getEvaluationActions} from "../../../../actions/evaluations";


const ApprovalYears = ({label, fieldName, isDisabled}) => {
  const dispatch = useDispatch();
  const {filtersData} = useSelector(state => state.pages.evaluations);

  // eslint-disable-next-line camelcase
  const maxApprovalYear = filtersData?.approval_years?.max ?? null;
  // eslint-disable-next-line camelcase
  const minApprovalYear = filtersData?.approval_years?.min ?? null;

  const approvalYearsOptions = [];
  if (maxApprovalYear !== null && minApprovalYear !== null) {
    for (let i = maxApprovalYear; i >= minApprovalYear; i -= 1) {
      approvalYearsOptions.push({label: i.toString(), value: i.toString()});
    }
  }

  const onChange = inputs => {
    if (inputs !== null && inputs.length > 0) {
      dispatch(advancedFilterActions.addFilter(fieldName, inputs, {
        approval_years: adaptInputValues(inputs)
      }));
    } else {
      dispatch(advancedFilterActions.removeFilter(fieldName));
    }
  };

  useEffect(() => {
     dispatch(getEvaluationActions().filtersData());
  }, [])

  return (
    <Field
      name={fieldName}
      label={label}
      component={Select}
      options={approvalYearsOptions}
      onChangeExtra={onChange}
      openMenuOnClick
      cssClass={Styles.noPaddingWithSpace}
      disabled={isDisabled}
      allowMultiple
    />
  )
}

export default ApprovalYears;